export default {"src":"/_next/static/media/ourvalues.ce17a45c.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};